enum NotificationEventType {
  NEW_DOCUMENT
  CASE_ALLOCATION
  NEW_SECURE_MESSAGE
}

enum WebPushSubscriptionStatus {
  active
  expired
  paused
  unknown
}

type NotificationEvent {
  notification_id: String!
  notification_type: NotificationEventType!
  document_type: DocumentKind
  message: String!
  subtext: String!
  url: String!
  created_at: String!
}

type NotificationToken {
  token: String!
}

type WebPushPublicKey {
  publicKey: String
}

type WebPushKeys {
  p256dh: String
  auth: String
}

type WebPushSubscription {
  id: String
  client_id: String
  endpoint: String
  keys: WebPushKeys
  status: WebPushSubscriptionStatus
  user_agent: String
  created: String
  updated: String
}

input WebPushKeysInput {
  p256dh: String!
  auth: String!
}

input WebPushSubscriptionInput {
  endpoint: String!
  keys: WebPushKeysInput!
}
